// Portal absorption (WS-D1) — the vendor "Review & requests" tab: the
// COLLECTION staging queue + document-request composer scoped by the
// vendor's linked portal account. Distinct from the vendor MONTHLY REPORT
// review flow, which stays on the Reports tab (VendorReportReviewDrawer)
// untouched — a caption line below makes that boundary explicit.

import { EmptyState } from "@/design-system/components/ui";
import { AccountReviewRequestsTab } from "@/components/portalAbsorption/AccountReviewRequestsTab";
import type { VendorDto } from "@/api/portfolioAdmin/types";
import { useVendorPortalAccount } from "@/hooks/portfolioAdmin/useRegistries";

export function VendorPortalReviewTab({ vendor }: { vendor: VendorDto }) {
  const portalQuery = useVendorPortalAccount(vendor.id);
  const portalUserId = portalQuery.data?.portalUserId ?? null;

  if (portalQuery.isLoading) {
    return <p className="text-caption text-gray-mid">Loading portal account…</p>;
  }
  if (!portalUserId) {
    return (
      <EmptyState
        title="No portal account"
        description="This vendor has no portal account yet — send the portal invitation from the Portal account tab first."
      />
    );
  }
  return (
    <div className="flex flex-col gap-space-2" data-testid="vendor-portal-review-tab">
      <p className="text-caption text-gray-mid m-0">
        Document requests &amp; submissions from this vendor&apos;s portal account.
        Monthly vendor reports are reviewed separately on the Reports tab.
      </p>
      <AccountReviewRequestsTab
        scope={{ portalUserId }}
        requestComposer={{
          accountType: "Vendor",
          email: vendor.email,
          // C1 — the vendor's own record is the created package's owner
          // (the review-time filing default).
          owner: { ownerEntityType: "Vendor", ownerEntityId: vendor.id },
        }}
        emptyMessage="Nothing has been submitted by this vendor yet."
      />
    </div>
  );
}
